module.exports = __webpack_public_path__ + "img/pudding.d8523579.svg";